import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const GetTransactions = createAsyncThunk(
  "getTransaction",
  async (lastEvalutedkey) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}transaction/list`,
        {
          lastEvalutedkey:
            lastEvalutedkey === "" ? { id: "0" } : lastEvalutedkey,
          limit: "50",
        }
      );
      if (res.data) {
        return res.data.res;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error);
      }
      if (error.message) {
        throw new Error(error.message);
      }
    }
  }
);

export default GetTransactions;
